/// <reference path="../../../../tools/typings/angularjs/angular.d.ts"/>
/// <reference path="../../components.ts"/>


module DealerwareWebComponents {

    "use strict";

    import IAgreementPage = DealerwareWebContent.IAgreementPage;

    export interface IDefineSignatureDateScope extends ng.IScope {
        selectedPage                                    : IAgreementPage;
        isPageSelected ()                               : boolean;
        isSignatureDefined ()                           : boolean;
        isDateDefined ()                                : boolean;
        goToPage (stepName: string)                     : void;
        setSignatureDateCoordinates (coordinates: any)  : void;
        deleteSignatureDateCoordinates (stepName: any)  : void;
        isCoordinateDataChanged ()                      : boolean;
        checkThisStep (stepName: any)                   : boolean;
        onSelectionBoxSizing (box: any)                 : void;
        getPageImageStyle ()                            : any;
        parentController                                : any;

        // @TODO : my casting of promises is lackadaisical throughout the app: fix.
        //
        saveLoanerAgreement (stepNameObject: any)       : ng.IPromise<any>;
    }

    export class DefineSignatureDateController {

        public static $inject : string[ ] = [
            '$scope', '$controller'
        ];

        private agreementSelections: any;


        constructor(
            private $scope: IDefineSignatureDateScope,
            private $controller: ng.IControllerService
        ) {

            this.$scope = $scope;

            this.$scope.getPageImageStyle = this.getPageImageStyle;

            this.agreementSelections = $controller(
                'AgreementSelectionsController', { $scope: this.$scope }
            );
        }

        public getPageImageStyle () : any {

            var that = this;

            return ( ) => {

                var page = that.$scope.selectedPage;

                return that.$scope.selectedPage && that.$scope.selectedPage.thumbnailHeight && that.$scope.selectedPage.thumbnailWidth ? {
                    height  : that.$scope.selectedPage.thumbnailHeight,
                    width   : that.$scope.selectedPage.thumbnailWidth,
                } : { };
            };
        }

        // None of these checks takes very long, which is good because the digest cycle
        // fires like ten thousand times every time you interact with the page.  It would
        // be better, but harder if we just checked flags to set ng-disabled on this button,
        // but that push method (setting those flags everywhere) would be more difficult and
        // buggy than this pull method.
        //
        public isSaveLoanerAgreementStepEnabled ( ) : boolean {

            // 1. On Select Page
            //
            // Page must be selected -- in this usage, 'selected' means
            // at least clicked on in the pages grid/navigator, but
            // not necessarily saved to the API)
            //
            if (this.checkThisStep('select-page') && ! this.$scope.isPageSelected()) {
                return false;
            }

            // 2. On Select The Signature Page
            //
            // Signature box must be drawn on the PDF, but as above not necessarily
            // saved to the API.
            //
            if (this.checkThisStep('set-signature') && ! this.$scope.isSignatureDefined()) {
                return false;
            }

            // 3. On Select The Define Page
            //
            // As with step 2, except regarding the Date box.
            //
            if (this.checkThisStep('set-date') && ! this.$scope.isDateDefined()) {
                return false;
            }

            //return this.$scope.isCoordinateDataChanged();
            return true;
        }

        public getSaveLoanerAgreementStepButtonText ( ) : string {
            return this.checkThisStep('set-date') ? 'Complete' : 'Continue';
        }

        private isSignatureClearButtonVisible ( ) : boolean {
            return this.$scope.isPageSelected()
                && this.checkThisStep('set-signature');
        }

        private isSignatureClearButtonEnabled ( ) : boolean {
            return this.isSignatureClearButtonVisible()
                && this.$scope.isSignatureDefined();
        }

        private isDateClearButtonVisible ( ) : boolean {
            return this.$scope.isPageSelected() && this.$scope.isSignatureDefined()
                && this.checkThisStep('set-date');
        }

        private isDateClearButtonEnabled ( ) : boolean {
            return this.isDateClearButtonVisible()
                && this.$scope.isDateDefined();
        }

        public getAllowedSelectionBoxIds ( ) : string[] {

            // Memoize?  Did someone just leave out the 'r' and think "well, that's good enough"?
            //
            return this.checkThisStep('set-signature') ?
                this.agreementSelections.allowedSelectionBoxIds['signature'] :
                this.checkThisStep('set-date') ?
                    this.agreementSelections.allowedSelectionBoxIds['date'] :
                        this.agreementSelections.allowedSelectionBoxIds['none'];
        }

        public setSignatureDateCoordinates ( box: any ) : void {

            this.$scope.setSignatureDateCoordinates( {
                stepName        : box.id,
                coordinateData  : box
            } );
        }

        public checkThisStep ( stepName: any ) : boolean {
            return this.$scope.checkThisStep( { stepName: stepName } );
        }

        public saveAndContinue ( ) : void {

            var nextStepName: string;

            if (this.checkThisStep('select-page') && this.$scope.isPageSelected()) {
                nextStepName = 'set-signature';
            }
            else if (this.checkThisStep('set-signature') && this.$scope.isSignatureDefined()) {
                nextStepName = 'set-date';
            }
            else if (this.checkThisStep('set-date') && this.$scope.isDateDefined()) {
                nextStepName = 'complete';
            }

            this.$scope.saveLoanerAgreement ({ stepName: nextStepName });
        }

        // Selection box can only be moved if we're on its page.
        //
        public disableSelectionBoxMove (box: any) : boolean {
            return ! this.checkThisStep(box.id);
        }

    }

    export class DefineSignatureDateDirective implements ng.IDirective {

        public restrict     : string    = 'E';
        public controller   : any       = 'DefineSignatureDateController';
        public controllerAs : string    = 'ctrl';
        public scope        : Object    = {

            // Checking for various data and page states.
            //
            isPageSelected      : '&',
            isSignatureDefined  : '&',
            isDateDefined       : '&',
            checkThisStep       : '&',

            // Doing actions against data (agreement) and page states.
            //
            getSelectedPageUrl  : '&',
            getPageImageStyle   : '&?',
            //goToPage            : '&',
            saveLoanerAgreement : '&',

            // Methods in set-directive to handle actions on selectedPage.
            //
            setSignatureDateCoordinates     : '&',
            deleteSignatureDateCoordinates  : '&',

            isCoordinateDataChanged: '&',

            activeSelectionId           : '=',
            selectedPage                : '='
        };
        public templateUrl  : string    = '/components/settings/loaner-agreement/define-signature-date-directive.html';
    }

    getDealerwareWebComponentsModule().controller(
        'DefineSignatureDateController',
        DefineSignatureDateController
    );

    getDealerwareWebComponentsModule().directive(
        'dealerwareLoanerAgreementDefineSignatureDate',
        ( ) => new DefineSignatureDateDirective()
    );
}
